<template>
  <div class="container-fluid first-view">
    <div class="background-overlay"></div>
    <action-alert :type="alert.type" :icon="alert.icon" :is-visible="alert.isVisible">{{alert.text}}</action-alert>
    <!--    <Breadcrumb :values="{ Home: '/', 'Fragrance Attributes': '' }"></Breadcrumb>-->
    <img class="logo" :src="logo"/>
    <template>
      <FragrancesAttributesFirstForm v-if="tab === 'first'"
                                     :form-data="formData"
                                     @select-attribute="changeSelectedAttribute"
                                     :searchFilters="searchFilters"
                                     :analytic-fields="analyticFields"
                                     :next-page="nextPage">
      </FragrancesAttributesFirstForm>
      <FragrancesAttributesSecondForm v-else-if="tab === 'second'"
                                      :form-data="formData"
                                      :selected-attribute="selectedAttribute"
                                      :searchFilters="searchFilters"
                                      :previous-page="previousPage"
                                      :next-page="nextPage">
      </FragrancesAttributesSecondForm>
      <FragrancesAttributesThirdForm v-else-if="tab === 'third'"
                                     :form-data="formData"
                                     :fields="parsedFields"
                                     :searchFilters="searchFilters"
                                     :yearsObject="yearsObject"
                                     :previous-page="previousPage"
                                     :next-page="nextPage"
                                     @update-dropdown-values="updateDropdownValues"
      >
      </FragrancesAttributesThirdForm>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapGetters } from 'vuex'

import ActionAlert from '../components/shared/ActionAlert'
import FragrancesAttributesFirstForm from '../components/FragrancesAttributes/FragrancesAttributesFirstForm'
import FragrancesAttributesSecondForm from '../components/FragrancesAttributes/FragrancesAttributesSecondForm'
import FragrancesAttributesThirdForm from '../components/FragrancesAttributes/FragrancesAttributesThirdForm'

import getInitialFilters from '../constants/searchFilters'
import studiesActions from '../store/modules/studies/actionTypes'
import generalActions from '../store/modules/general/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import generalGetters from '../store/modules/general/getterTypes'
import logo from '../assets/images/logos/Iris-Grey.svg'

export default {
  name: 'FragrancesAttributes',
  components: {
    ActionAlert,
    FragrancesAttributesFirstForm,
    FragrancesAttributesSecondForm,
    FragrancesAttributesThirdForm
  },
  data () {
    return {
      formData: {
        radioDesc: 'best',
        radioPercentType: 'number',
        year: [],
        attribute: '',
        attributeType: ''
      },
      selectedAttribute: '',
      searchFilters: {},
      parsedFields: {},
      analyticFields: {},
      tab: 'first',
      yearsObject: null,
      alert: {
        type: '',
        icon: '',
        text: '',
        isVisible: false
      },
      logo
    }
  },
  computed: {
    ...mapGetters({
      fields: studiesGetters.GET_FIELDS,
      alertMessage: generalGetters.GET_ALERT_MESSAGE,
      alertType: generalGetters.GET_ALERT_TYPE
    })
  },
  methods: {
    ...mapActions({
      getFields: studiesActions.FETCH_FIELDS,
      getAnalyticsFields: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      setOrClearFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS,
      toggleLoading: generalActions.TOGGLE_LOADING
    }),
    nextPage () {
      if (this.tab === 'first') {
        const attributeType = `Attribute: ${this.formData.attributeType} `
        this.$set(this.searchFilters.metrics.metricsList[0].metricType, 'value', attributeType)
        this.$set(this.searchFilters.metrics.metricsList[0].metric, 'value', this.formData.attribute)
        this.tab = 'second'
      } else if (this.tab === 'second') {
        if (this.formData.radioDesc === 'top') {
          this.$set(this.searchFilters.metrics.threshold, 'desc', false)
        } else {
          this.$set(this.searchFilters.metrics.threshold, 'desc', true)
        }

        this.$set(this.searchFilters.metrics.metricsList[0].aggregation, 'value', 'top_2_box')

        if (this.formData.radioPercentType === 'number') {
          this.$set(this.searchFilters.metrics.threshold, 'type', 'fragrances')
        } else {
          this.$set(this.searchFilters.metrics.threshold, 'type', 'percentage')
        }
        this.tab = 'third'
      } else if (this.tab === 'third') {
        this.$set(this.searchFilters.metrics.threshold, 'applyThreshold', true)
        this.handleSearch()
      }
    },
    previousPage () {
      if (this.tab === 'third') this.tab = 'second'
      else if (this.tab === 'second') this.tab = 'first'
    },
    handleSearch () {
      this.setOrClearFilters({ 'clearFilters': false, filters: this.searchFilters })
    },
    changeSelectedAttribute (value) {
      this.selectedAttribute = value
    },
    parseAnalytics (analyticFields) {
      const analyticsData = analyticFields.find(el => el.group_label === 'aggregation').data
      this.analyticFields = {
        'aggregations': analyticsData.aggregations,
        'threshold': analyticsData.threshold,
        'attributes_types': analyticFields.find(el => el.group_label === 'attributes_metadata').data.attribute_type,
        'attributes': {}
      }

      const metrics = analyticFields.find(el => el.group_label === 'metrics').data

      for (let i = 0; i < metrics.length; ++i) {
        const { name, field, type } = metrics[i]
        if (this.analyticFields.attributes[type] == null) {
          this.analyticFields.attributes[type] = [{ 'name': name, 'field': field }]
        } else {
          this.analyticFields.attributes[type] = this.analyticFields.attributes[type]
            .concat({ 'name': name, 'field': field })
        }
      }
    },
    parseFields (fields) {
      const seekingFields = ['Business Unit', 'Category', 'Client', 'Product Type', 'Region', 'Year']
      const collectedFields = {}

      const data = fields[0]['data']
      for (let i = 0; i < data.length; ++i) {
        if (seekingFields.includes(data[i].label)) {
          if (data[i].type === 'category') {
            const options = []
            for (let j = 0; j < data[i].options.length; ++j) {
              let { count, value } = data[i].options[j]
              if (data[i].label === 'Year') value = parseInt(value)
              options.push([value, count])
            }

            collectedFields[data[i].label] = options
          }
        }
      }

      this.parsedFields = collectedFields
      const years = [...this.parsedFields['Year']]
      const [firstYear, lastYear] = [years[0][0], years[years.length - 1][0]]
      this.formData.year = [String(firstYear), String(lastYear)]
      this.yearsObject = {
        min: firstYear,
        max: lastYear,
        marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) }
      }
    },
    updateDropdownValues (values) {
      this.parseFields(values)
    }
  },
  async beforeMount () {
    if (!this.searchFilters.length) {
      this.toggleLoading(true)
      const analyticFields = (await this.getAnalyticsFields({ query: [], query_metrics: [] })).data.fields
      const nestedData = analyticFields.find(el => el.group_label === 'analytics')
      this.parseAnalytics(nestedData.data)
      this.parseFields(analyticFields)
      this.searchFilters = _.cloneDeep(getInitialFilters.getInitialFilters())
      this.toggleLoading(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.container-fluid.first-view {
  padding: 99px 87px !important;
  background-image: url("../assets/images/backgrounds/IRIS-background-720p.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .background-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #2A274B;
    opacity: 0.4;
  }
}

.logo {
  position: fixed;
  bottom: 20px;
  right: 50px;
  width: 6.5%;
  height: auto;
}

.container-fluid {
  height: 100%;
}
</style>
